<script>
  import propsBinder from 'vue2-leaflet/src/utils/propsBinder.js'
  import findRealParent from 'vue2-leaflet/src/utils/findRealParent.js'
  import {
    optionsMerger
  } from 'vue2-leaflet/src/utils/optionsUtils.js'
  import L from 'leaflet'
  import LayerGroup from 'vue2-leaflet/src/mixins/LayerGroup.js'
  // import _ from 'lodash'
  import Windy from './windy.js'

  L.DomUtil.setTransform = L.DomUtil.setTransform || function (el, offset, scale) {
    let pos = offset || new L.Point(0, 0)

    el.style[L.DomUtil.TRANSFORM] = (L.Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '')
  }

// -- support for both  0.0.7 and 1.0.0 rc2 leaflet
L.CanvasLayer = (L.Layer ? L.Layer : L.Class).extend({
  // -- initialized is called on prototype
    initialize: function initialize (options) {
      this._map = null
      this._canvas = null
      this._frame = null
      this._delegate = null
      L.setOptions(this, options)
    },

    delegate: function delegate (del) {
      this._delegate = del
      return this
    },

    needRedraw: function needRedraw () {
      if (!this._frame) {
        this._frame = L.Util.requestAnimFrame(this.drawLayer, this)
      }
      return this
    },

    // -------------------------------------------------------------
    _onLayerDidResize: function _onLayerDidResize (resizeEvent) {
      this._canvas.width = resizeEvent.newSize.x
      this._canvas.height = resizeEvent.newSize.y
    },
    // -------------------------------------------------------------
    _onLayerDidMove: function _onLayerDidMove () {
      let topLeft = this._map.containerPointToLayerPoint([0, 0])
      L.DomUtil.setPosition(this._canvas, topLeft)
      this.drawLayer()
    },
    // -------------------------------------------------------------
    getEvents: function getEvents () {
      let events = {
        resize: this._onLayerDidResize,
        moveend: this._onLayerDidMove
      }
      if (this._map.options.zoomAnimation && L.Browser.any3d) {
        events.zoomanim = this._animateZoom
      }

      return events
    },
    // -------------------------------------------------------------
    onAdd: function onAdd (map) {
      this._map = map
      this._canvas = L.DomUtil.create('canvas', 'leaflet-layer')
      this.tiles = {}
      L.DomUtil.setTransform(this._canvas, {
        x: -this._map._mapPane._leaflet_pos.x,
        y: -this._map._mapPane._leaflet_pos.y
      })
      let size = this._map.getSize()
      this._canvas.width = size.x
      this._canvas.height = size.y

      let animated = this._map.options.zoomAnimation && L.Browser.any3d
      L.DomUtil.addClass(this._canvas, 'leaflet-zoom-' + (animated ? 'animated' : 'hide'))

      map._panes.overlayPane.appendChild(this._canvas)

      map.on(this.getEvents(), this)

      let del = this._delegate || this
      del.onLayerDidMount && del.onLayerDidMount() // -- callback
      this.needRedraw()
    },

    // -------------------------------------------------------------
    onRemove: function onRemove (map) {
      let del = this._delegate || this
      del.onLayerWillUnmount && del.onLayerWillUnmount() // -- callback

      map.getPanes().overlayPane.removeChild(this._canvas)

      map.off(this.getEvents(), this)

      this._canvas = null
    },

    // ------------------------------------------------------------
    addTo: function addTo (map) {
      map.addLayer(this)
      return this
    },
    // --------------------------------------------------------------------------------
    LatLonToMercator: function LatLonToMercator (latlon) {
      return {
        x: latlon.lng * 6378137 * Math.PI / 180,
        y: Math.log(Math.tan((90 + latlon.lat) * Math.PI / 360)) * 6378137
      }
    },

    // ------------------------------------------------------------------------------
    drawLayer: function drawLayer () {
      // -- todo make the viewInfo properties  flat objects.
      let size = this._map.getSize()
      let bounds = this._map.getBounds()
      let zoom = this._map.getZoom()

      let center = this.LatLonToMercator(this._map.getCenter())
      let corner = this.LatLonToMercator(this._map.containerPointToLatLng(this._map.getSize()))

      let del = this._delegate || this
      del.onDrawLayer && del.onDrawLayer({
        layer: this,
        canvas: this._canvas,
        bounds: bounds,
        size: size,
        zoom: zoom,
        center: center,
        corner: corner
      })
      this._frame = null
    },
    // -- L.DomUtil.setTransform from leaflet 1.0.0 to work on 0.0.7
    // ------------------------------------------------------------------------------
    _setTransform: function _setTransform (el, offset, scale) {
      let pos = offset || new L.Point(0, 0)

      el.style[L.DomUtil.TRANSFORM] = (L.Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '')
    },

    // ------------------------------------------------------------------------------
    _animateZoom: function _animateZoom (e) {
      let scale = this._map.getZoomScale(e.zoom)
      // -- different calc of offset in leaflet 1.0.0 and 0.0.7 thanks for 1.0.0-rc2 calc @jduggan1
      let offset = L.Layer ? this._map._latLngToNewLayerPoint(this._map.getBounds().getNorthWest(), e.zoom, e.center) : this._map._getCenterOffset(e.center)._multiplyBy(-scale).subtract(this._map._getMapPanePos())

      L.DomUtil.setTransform(this._canvas, offset, scale)
    }
})

L.canvasLayer = function () {
    return new L.CanvasLayer()
}

L.Map.mergeOptions({
    positionControl: false
})

L.VelocityLayer = (L.Layer ? L.Layer : L.Class).extend({
    options: {
      displayValues: false,
      maxVelocity: 30, // used to align color scale
      colorScale: null,
      data: null
    },

    _map: null,
    _canvasLayer: null,
    _windy: null,
    _context: null,
    _timer: 0,
    _mouseControl: null,

    initialize: function initialize (options) {
      L.setOptions(this, options)
    },

    onAdd: function onAdd (map) {
      // create canvas, add overlay control
      this._canvasLayer = L.canvasLayer().delegate(this)
      this._canvasLayer.addTo(map)
      this._map = map
    },

    onRemove: function onRemove (map) {
      this._destroyWind()
    },

    setData: function setData (data) {
      this.options.data = data

      if (this._windy) {
        this._windy.setData(data)
        this._clearAndRestart()
      }

      this.fire('load')
    },

    /* ------------------------------------ PRIVATE ------------------------------------------ */

    onDrawLayer: function onDrawLayer (overlay, params) {
      let self = this

      if (!this._windy) {
        this._initWindy(this)
        return
      }
      if (!this.options.data) {
        return
      }

      if (this._timer) clearTimeout(self._timer)

      this._timer = setTimeout(function () {
        self._startWindy()
      }, 750) // showing velocity is delayed
    },

    _startWindy: function _startWindy () {
      let bounds = this._map.getBounds()
      let size = this._map.getSize()
      // bounds, width, height, extent
      this._windy.start([[0, 0], [size.x, size.y]], size.x, size.y, [[bounds._southWest.lng, bounds._southWest.lat], [bounds._northEast.lng, bounds._northEast.lat]])
    },

    _initWindy: function _initWindy (self) {
      // windy object
      this._windy = new Windy({
        canvas: self._canvasLayer._canvas,
        data: self.options.data,
        velocityScale: self.options.velocityScale || 0.005,
        minVelocity: self.options.minVelocity || 0,
        maxVelocity: self.options.maxVelocity || 10,
        particleWidth: self.options.particleWidth || 1,
        colorScale: self.options.colorScale || null
      })

      // prepare context global let, start drawing
      this._context = this._canvasLayer._canvas.getContext('2d')
      this._canvasLayer._canvas.classList.add('velocity-overlay')
      this.onDrawLayer()

      this._map.on('dragstart', self._windy.stop)
      this._map.on('dragend', self._clearAndRestart)
      this._map.on('zoomstart', self._windy.stop)
      this._map.on('zoomend', self._clearAndRestart)
      this._map.on('resize', self._clearWind)
    },

    _clearAndRestart: function _clearAndRestart () {
      if (this._context) this._context.clearRect(0, 0, 3000, 3000)
      if (this._windy) this._startWindy()
    },

    _clearWind: function _clearWind () {
      if (this._windy) this._windy.stop()
      if (this._context) this._context.clearRect(0, 0, 3000, 3000)
    },

    _destroyWind: function _destroyWind () {
      if (this._timer) clearTimeout(this._timer)
      if (this._windy) this._windy.stop()
      if (this._context) this._context.clearRect(0, 0, 3000, 3000)
      this._windy = null
      this._map.removeLayer(this._canvasLayer)
    }
})

L.velocityLayer = function (options) {
    return new L.VelocityLayer(options)
}

if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id)
    }
}

export default {
    name: 'LVectorLeaflet',
    mixins: [LayerGroup],
    props: {
      geojson: {
        type: [Object, Array],
        custom: true,
        default: () => ({})
      },
      options: {
        type: Object,
        custom: true,
        default: () => ({})
      }
    },
    computed: {
      mergedOptions () {
        return optionsMerger({
          ...this.layerGroupOptions
        }, this)
      }
    },
    mounted () {
      this.mapObject = L.velocityLayer(this.options)
      this.mapObject.setData(this.geojson)
      L.DomEvent.on(this.mapObject, this.$listeners)
      propsBinder(this, this.mapObject, this.$options.props)
      this.parentContainer = findRealParent(this.$parent, true)
      this.parentContainer.addLayer(this, !this.visible)
    },
    beforeDestroy () {
      this.parentContainer.mapObject.removeLayer(this.mapObject)
    },
    methods: {
      setGeojson (newVal) {
        // this.mapObject.clearLayers()
        this.mapObject.setData(newVal)
      },
      getBounds () {
        return this.mapObject.getBounds()
      },
      setOptions (newVal, oldVal) {
        // this.mapObject.clearLayers()
        L.setOptions(this.mapObject, this.mergedOptions)
        this.mapObject.setData(this.geojson)
      },
      setOptionsStyle (newVal, oldVal) {
        this.mapObject.setStyle(newVal)
      }
    },
    render () {
      return null
    }
}
</script>



// WEBPACK FOOTER //
// src/components/map/LVectorLeaflet.vue